import menu from "./src/menu";
import manageDocHeight from "./src/manage-doc-height";
import search from "./src/search-popup";
import partnerSwiper from "./src/partners-swiper";
import initSafeMailDisplay from "./src/safe-mail";
import accordion from "./src/accordion"
import slider from "./src/slider"
import frontpageNewsSlider from "./src/frontpage-news-slider";
import termList from './src/term-list';
import initStickyBtn from "./src/sticky-btn";
import initArrowLinks from "./src/arrow-link-buttons";

window.addEventListener('DOMContentLoaded', function() {
	// Menu header
	menu.init();

	// Gestion de la variable css --vh pour la mixin sass vh()
	manageDocHeight.init();

	// Popup formulaire de recherche
	search.init();

	// Footer partners swiper
	partnerSwiper.init();

	// Bloc accordéon
	accordion.init();

	// Bloc slider
	slider.init();

	// Slider des actus de la home (pour mobile)
	frontpageNewsSlider.init();

	// Gestion du filtre actu/evenement
	termList.init();

	// Display email safely to avoid spam
	initSafeMailDisplay();

	// Scroll event for sticky button
	initStickyBtn();

	// Add data-text attributes on .btn--arrow links
	initArrowLinks();
});